module.exports = __webpack_public_path__ + "static/media/not-found.6695af99.svg";